module.exports = __webpack_public_path__ + "static/media/verbandkasten_frage.3f4c3994.png";